import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import { getTimestamp } from './utils/timestamp';
import { formatTime } from './utils/formatters';

var Stats = function () {
  function Stats(_ref) {
    var id = _ref.id;

    _classCallCheck(this, Stats);

    this.id = id;
    this.time = getTimestamp();
    this.counters = {};
    Object.seal(this);
  }

  _createClass(Stats, [{
    key: "addCounter",
    value: function addCounter(name) {
      this._getCounter(name);

      return this;
    }
  }, {
    key: "bump",
    value: function bump(name) {
      var counter = this._getCounter(name);

      counter.call++;
      counter.count++;
      return this;
    }
  }, {
    key: "increment",
    value: function increment(name, count) {
      var counter = this._getCounter(name);

      counter.call++;
      counter.count += count;
      return this;
    }
  }, {
    key: "addTimer",
    value: function addTimer(name) {
      var timer = this._getCounter(name);

      timer.time = 0;
      return this;
    }
  }, {
    key: "addTime",
    value: function addTime(name, time) {
      var timer = this._getCounter(name);

      timer.time += time;
      timer.count++;
      return this;
    }
  }, {
    key: "timeStart",
    value: function timeStart(name, subname) {
      var timer = this._getCounter(name);

      timer._startTime = getTimestamp();
    }
  }, {
    key: "timeEnd",
    value: function timeEnd(name, subname) {
      var timer = this._getCounter(name);

      this.addTime(name, getTimestamp() - timer._startTime);
    }
  }, {
    key: "reset",
    value: function reset() {
      this.time = getTimestamp();

      for (var key in this.counters) {
        var counter = this.counters[key];
        counter.count = 0;
        counter.time = 0;
      }

      return this;
    }
  }, {
    key: "hasTimeElapsed",
    value: function hasTimeElapsed() {
      var deltaTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
      return getTimestamp() - this.time > 1000;
    }
  }, {
    key: "getStats",
    value: function getStats() {
      var deltaTime = (getTimestamp() - this.time) / 1000;
      var stats = {};

      for (var key in this.counters) {
        var counter = this.counters[key];
        stats[counter.title] = {
          total: counter.count,
          fps: Math.round(counter.count / deltaTime)
        };

        if (counter.time) {
          stats[counter.title].totalTime = formatTime(counter.time);
          stats[counter.title].avgTime = formatTime(counter.time / counter.count);
        }
      }

      return stats;
    }
  }, {
    key: "getStatsTable",
    value: function getStatsTable() {
      var stats = this.getStats();

      for (var key in stats) {
        if (stats[key].total === 0) {
          delete stats[key];
        }
      }

      return stats;
    }
  }, {
    key: "getStatNames",
    value: function getStatNames() {
      return Object.keys(this.counters);
    }
  }, {
    key: "get",
    value: function get(name) {
      var counter = this._getCounter(name);

      return counter.count;
    }
  }, {
    key: "getCount",
    value: function getCount(name) {
      var counter = this._getCounter(name);

      return counter.count;
    }
  }, {
    key: "getFPS",
    value: function getFPS(name) {
      var counter = this._getCounter(name);

      var deltaTime = (getTimestamp() - this.time) / 1000;
      return Math.round(counter.count / deltaTime);
    }
  }, {
    key: "getTimeString",
    value: function getTimeString() {
      return "".concat(this.id, ":").concat(formatTime(this.time), "(").concat(this.count, ")");
    }
  }, {
    key: "oneSecondPassed",
    value: function oneSecondPassed() {
      var deltaTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
      return this.hasTimeElapsed(deltaTime);
    }
  }, {
    key: "_getCounter",
    value: function _getCounter(name) {
      var counter = this.counters[name];

      if (!counter) {
        counter = {
          title: name,
          unit: '',
          timer: false,
          count: 0,
          time: 0,
          totalTime: 0,
          averageTime: 0
        };
        this.counters[name] = counter;
      }

      return counter;
    }
  }, {
    key: "_incrementTimer",
    value: function _incrementTimer(counter, time, count) {
      counter.count += count;
      counter.totalTime += time;
      counter.averageTime = counter.totalTime / count;
    }
  }]);

  return Stats;
}();

export { Stats as default };
//# sourceMappingURL=stats.js.map


//////////////////
// WEBPACK FOOTER
// ./~/probe.gl/dist/esm/lib/stats.js
// module id = 1635
// module chunks = 0